import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const WorkingMemoryTest = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);

  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {

    const email = localStorage.getItem("user_email");

    if (!email) {
      navigate("/");
      return;
    }

    axios
      .get(`/check-access?email=${email}&test=working_memory`)
      .then(res => {

        console.log("API:", res.data); // 👈 debug

        if (res.data.allowed) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }

      })
      .catch(() => navigate("/"));

  }, []);

  // 🔥 THIS PART IS VERY IMPORTANT

  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  if (hasAccess === false) {
    return (
      <div className="access-denied-container">
        <h2>🚫 Access Denied</h2>
        <p>You don’t have access to this test</p>
        <button onClick={() => navigate("/")}>Go Back</button>
      </div>
    );
  }
  

  return (
    <div className="rg-login-wrapper">

      {/* ================= HEADER SECTION ================= */}

      <div className="reaction-header-card">

        <h2 className="reaction-title">Working Memory Test</h2>

        <p className="reaction-subtitle">
          Working memory measures your ability to temporarily store and recall information.
          It trains the brain to 
          <strong> “Observe → Hold → Recall.”</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Memory → Working Memory Capacity</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY SECTION ================= */}

        <div className="reaction-why-card">

          <h3 className="why-title">
            Why working memory matters
          </h3>

          <p className="why-description">
            Working memory is essential for learning, decision making, and performance under pressure.
            It helps you retain and use information in real-time — critical in sports, academics,
            and everyday problem solving.
          </p>

          <div className="why-tags">
            <span>Stronger memory retention</span>
            <span>Better focus</span>
            <span>Faster thinking</span>
            <span>Improved decision making</span>
            <span>Enhanced concentration</span>
          </div>

        </div>

      </div>

      {/* ================= HOW GAME WORKS ================= */}

      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">

          <li>
            A sequence of numbers will be displayed on the screen.
          </li>

          <li>
            Memorize the sequence carefully.
          </li>

          <li>
            Once it disappears, enter the sequence correctly.
          </li>

          <li>
            The sequence length increases with each level.
          </li>

          <li>
            The game ends when you make a mistake.
          </li>

        </ul>

        <p className="how-note">
          Tip: Stay calm and focused for better recall.
        </p>

      </div>

      {/* ================= START TEST ================= */}

      <div className="start-test-section">

        <h2>Ready to test your memory?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/working-memory/play")}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default WorkingMemoryTest;